module.exports = __webpack_public_path__ + "img/conteudo-datas.c02dda80.png";